module.exports = __webpack_public_path__ + "static/media/trainerVLSI.be4ca15f.jpeg";